import { Pipe, PipeTransform } from '@angular/core';
import { ALERT_TYPE } from '@app/_shared/shared.enums';

@Pipe({
  name: 'alertType'
})
export class AlertTypePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): unknown {
    return ALERT_TYPE[value];
  }

}
